<template>
  <div :class="$options.name">
    <v-card>
      <data-table
        ref="data-table"
        reference="data-table"
        :list="data.list"
        :is-loading="isLoading"
        :headers="headers"
        :options.sync="options"
        :pagination="data.pagination"
        @change-page="onChangePage"
      >
        <template #toolbar>
          <create-button
            dialog="dangerous-informers-dialog"
            :permissions="['dangerous-informers-create']"
          />
          <div class="flex-grow-1" />
          <search-filter
            ref="search-filter"
            v-model="data"
            original-module="dangerousInformers"
            name-filter
            region-filter
            :data-table-options="options"
            :is-loading.sync="isLoading"
            :page="page"
          />
        </template>

        <template #item.actions="{ item }">
          <div class="data-table-actions">
            <edit-button
              :permissions="['dangerous-informers-edit']"
              dialog="dangerous-informers-dialog"
              :disabled="isLoading"
              :item="item"
            />
            <delete-button
              :permissions="['dangerous-informers-delete']"
              :disabled="isLoading"
              :item-id="item.id"
            />
          </div>
        </template>
      </data-table>
      <dangerous-informers-dialog @submit="submit" />
      <remove-confirmation
        name="remove-confirmation"
        title="Вы действительно желаете удалить элемент?"
        @confirmed="onRemove"
      />
    </v-card>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import DataTable from '@/components/common/data-table';
import CreateButton from '@/components/common/create-button';
import EditButton from '@/components/common/edit-button';
import SearchFilter from '@/components/common/search-filter';
import DeleteButton from '@/components/common/delete-button';
import RemoveConfirmation from '@/components/dialogs/confirmations/RemoveConfirmation.vue';
import DangerousInformersDialog from './components/DangerousInformersDialog.vue';

export default {
  name: 'dangerous-informers-list',
  asyncData({ store }) {
    const actions = [
      store.dispatch('filters/getAvailable', { adminLevel: 4 }),
    ];

    return Promise.all(actions);
  },
  components: {
    SearchFilter,
    DeleteButton,
    EditButton,
    DataTable,
    DangerousInformersDialog,
    CreateButton,
    RemoveConfirmation,
  },
  data: () => ({
    data: { list: [], pagination: {}, isSearch: false },
    page: 1,
    isLoading: false,
    headers: [
      { value: 'name', text: 'Название', sortable: true },
      { value: 'region.name', text: 'Регион', sortable: false },
      { value: 'actions', sortable: false, width: '20%' },
    ],
    options: {},
  }),
  methods: {
    ...mapActions('dangerousInformers', {
      createInformer: 'create',
      destroyInformer: 'remove',
      updateInformer: 'update',
    }),

    submit(data) {
      this.viaLoading(async () => {
        const points = JSON.stringify(data.points);
        if (!data.isEdit) {
          await this.createInformer({ ...data.form, points });
        } else {
          await this.updateInformer({ ...data.form, points });
        }

        await this.updateData(this.page);
      });
    },

    onRemove(id) {
      this.viaLoading(async () => {
        await this.destroyInformer(id);
        await this.updateData();
      });
    },

    onChangePage(page) {
      this.page = page;
    },

    async viaLoading(cb) {
      this.isLoading = true;
      await cb();
      this.isLoading = false;
    },

    async updateData(page = null) {
      await this.$refs['search-filter'].getTableList(page);
    },
  },
};
</script>

<style scoped>

</style>
